var _defs, _line, _line2, _line3, _line4, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack164({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 15,
    y1: 8,
    x2: 11.95,
    y2: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 4.05,
    y1: 8,
    x2: 1,
    y2: 8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 8,
    y1: 1,
    x2: 8,
    y2: 4.05
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 8,
    y1: 15,
    x2: 8,
    y2: 11.95
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,4.05A4,4,0,0,0,4.05,8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,12A4,4,0,0,0,12,8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12,8A4,4,0,0,0,8,4.05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.05,8A4,4,0,0,0,8,12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack164);
export default __webpack_public_path__ + "static/media/Symbolpack_1_64.32596b52c497b29ec03055b46ac46295.svg";
export { ForwardRef as ReactComponent };